import React, { useState } from "react";

//UI Material
import {
  Button,
  CircularProgress,
  Grid,
  Stack,
  SwipeableDrawer,
  Typography,
} from "@mui/material";

//Helpers
import { fetchWithTokenJSONPost } from "../../Helpers/network";

//Material Icons
import { Add, Cancel, Category } from "@mui/icons-material";

//Local components
import Form from "../basics/Form";
import ModalWindow from "../Modal";

export default function SetItemCategoryDrawer({ open, setOpen, getData }) {
  // ==========>Component States<==========
  //State for productData
  const [categoryData, setCategoryData] = useState({});
  //State fpr setting loader
  const [isLoading, setIsLoading] = useState(false);
  //State for open modal
  const [modalOpen, setModalOpen] = useState(false);
  //State for modal text
  const [modalText, setModalText] = useState("");
  //State for modal description
  const [modalDescription, setModalDescription] = useState("");

  const addCategoryForm = [
    {
      selection: "textfield",
      id: "name",
      initialValue: categoryData.name,
      xs: 12,
      md: 6,
      label: "Nombre de la categoría",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Nombre de la categoría",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "prefix",
      initialValue: categoryData.prefix,
      xs: 12,
      md: 6,
      label: "Prefijo para identificadores",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Prefijo para identificadores",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "description",
      initialValue: categoryData.description,
      xs: 12,
      md: 12,
      label: "Descripción de la categoría",
      multiline: true,
      type: "text",
      inputProps: {},
      placeholder: "Descripción de la categoría",
      content: [],
      style: {},
    },
  ];

  //Function to create new product
  const setCategory = async () => {
    setIsLoading(true);

    const newCategory = {
      name: categoryData.name,
      description: categoryData.description,
      prefix: categoryData.prefix,
    };

    try {
      const requestResponse = await fetchWithTokenJSONPost(
        "/inventory/create-category",
        newCategory
      );
      const jsonResponse = await requestResponse.json();

      if (jsonResponse.status === "ok") {
        setModalText("Categoría registrada exitosamente.");
        setModalDescription(jsonResponse.description);
        getData();
        setOpen(false);
      } else {
        setModalText("No se pudo realizar la acción.");
        setModalDescription(jsonResponse.description);
      }
    } catch (error) {
      console.log(error);
    }
    setModalOpen(true);
    setIsLoading(false);
  };

  return (
    <SwipeableDrawer
      anchor="bottom"
      transitionDuration={600}
      disableSwipeToOpen={true}
      open={open}
      sx={{
        zIndex: "99",
        "& .MuiDrawer-paper": {
          justifyContent: "center",
          borderRadius: "35px 35px 0px 0px",
        },
      }}
      onClose={() => setOpen(false)}
      onOpen={() => {
        /**empty arrow function */
      }}
    >
      <Grid
        container
        justifyContent="center"
        sx={{ padding: "15px" }}
        textAlign="center"
        spacing={1}
      >
        <Grid item xs={12} sx={{ marginTop: "10px" }}>
          <Category color="secondary" />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h7" fontWeight="bold" color="secondary">
            Nueva categoría
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Form data={addCategoryForm} handleStateChange={setCategoryData} />
        </Grid>
        <Grid item xs={12} sx={{ marginTop: "10px" }}>
          <Stack direction="row" spacing={1} justifyContent="center">
            <Button
              size="small"
              variant="contained"
              color="error"
              sx={{ color: "white" }}
              endIcon={<Cancel />}
              onClick={() => {
                setOpen(false);
              }}
            >
              Cancelar
            </Button>
            {isLoading ? (
              <CircularProgress />
            ) : (
              <Button
                size="small"
                variant="contained"
                color="secondary"
                sx={{ color: "white" }}
                endIcon={<Add />}
                disabled={categoryData.name === ""}
                onClick={setCategory}
              >
                Registrar categoría
              </Button>
            )}
          </Stack>
        </Grid>
      </Grid>
      <ModalWindow
        isOpen={modalOpen}
        handleClose={() => setModalOpen(false)}
        title={modalText}
        text={modalDescription}
        leftText="OK"
        leftClick={() => {
          setModalOpen(false);
        }}
      />
    </SwipeableDrawer>
  );
}
